// Russian descriptions for international listings.
// Keyed by listing.slug (stable, manually managed).

const internationalDescriptionsRu = {
  "la-alqueria-benahavis-villa": `Вилла на продажу в Ла Алькерия, Бенаависе: 5 спален, 5 ванных комнат, частный бассейн, гараж на 3 машины и частный сад.

Объект построен из материалов высшего качества с уникальным дизайном каждой комнаты. Открытый бассейн-инфинити с панорамным видом на море и горы окружён джакузи и зоной отдыха с шезлонгами. На крытой террасе расположена зона барбекю в окружении тропического сада.

Площадь: 1 266 м² жилой площади и 2 254 м² участок.`,

  "villa-c44-phuket": `Вилла C44 — полностью готовая к проживанию премиальная вилла в комьюнити Clover Residence, Пхукет.

Уникальное расположение — 50 м до международной школы HeadStart, 4,5 км до моря. С одной стороны нет соседей — исключительная приватность.

Общая жилая площадь 351,80 м², озеленённая площадь 132,72 м², земельный участок 484,52 м². Вилла оснащена частным бассейном, утопленной лаунж-террасой, гаражом на 3 автомобиля, главной спальней с ванной комнатой, двумя дополнительными спальнями и просторной кухней-гостиной площадью 81,25 м².

Продаётся напрямую от владельца — на 6 млн THB ниже цены застройщика. Строительство контролировалось независимой экспертной организацией; все отчёты и документация передаются новому владельцу.

Арендный доход: 2,5 млн THB в год. Доходность: 8–10%. Оплата банковским переводом или криптовалютой.`,
};

export default internationalDescriptionsRu;
